import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { LocalStorageService } from 'ngx-webstorage';
import { formatDate } from '@angular/common';
import {ViewEncapsulation} from '@angular/core';

import { PatientDocumentsModel } from 'src/app/models/PatientDocumentsModel';
import { DataBankService } from 'src/app/services/DataBankService';
import { DatabankModel } from 'src/app/models/DataBankModel';
import { PopuppatientsearchComponent } from '../popuppatientsearch/popuppatientsearch.component';
import { PatientDocumentsService } from 'src/app/services/PatientDocumentsService';
import { PatientDocumentsEditComponent } from '../patient-documents-edit/patient-documents-edit.component';
import { URLsConfig } from 'src/app/URLsConfig';
import { DomSanitizer } from '@angular/platform-browser';


@Component({
  selector: 'app-patient-document-new',
  templateUrl: './patient-document-new.component.html',
  styleUrls: ['./patient-document-new.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class PatientDocumentNewComponent implements OnInit {
  id = 0 ;
  patientcode = '' ;
  patientname = '';
  doccode = '' ;
  docname = '' ;
  docdate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
  doctype = '' ;
  pathimage = '' ;
  fileBytes ='';
  docnotes = '';
  userid = '' ;
  modifieddate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
  compcode = '1' ;
  wk_url = '';
  Wk_DocCode = 0;
    myimage :any;
    PatientDocumentsLabList: PatientDocumentsModel[] = [];
    PatientDocumentsPathologyList: PatientDocumentsModel[] = [];
    PatientDocumentsImageList: PatientDocumentsModel[] = [];
    PatientDocumentsTestList: PatientDocumentsModel[] = [];
    PatientDocumentsPhotoList: PatientDocumentsModel[] = [];
    PatientDocumentsOtherList: PatientDocumentsModel[] = [];
    PatientDocumentsTreatmnetList: PatientDocumentsModel[] = [];
    PatientDocumentsRadioList :PatientDocumentsModel[] = [];

    @Output() submitClicked = new EventEmitter<any>();

    constructor(public storage: LocalStorageService,
                public dataBankService : DataBankService,
                public patientsSelectedData :DatabankModel,
                public patientdocumentsservice : PatientDocumentsService,
                public patientdocuments : PatientDocumentsModel,
                private dialogref: MatDialog,
                public urlsconfig: URLsConfig,
                private sanitizer: DomSanitizer,
               ) { }

    ngOnInit(): void {
      this.patientcode = this.storage.retrieve('stgPatientCode');
      this.RertivePatient();
    }
    RertivePatient(){

      this.dataBankService.getPatient(this.patientcode,this.compcode).subscribe((data: DatabankModel) => {
        this.patientname = data.patientFName;

      })
      this.RetrivePatientDocumentsLab();
      this.RetrivePatientDocumentsPathology();
      this.RetrivePatientDocumentsImage();
      this.RetrivePatientDocumentsTest();
      this.RetrivePatientDocumentsPhoto();
      this.RetrivePatientDocumentsOther();
      this.RetrivePatientDocumentsTreatment();
      this.RetrivePatientDocumentsRadio();
    }
    OpenEmployeeDialog(){
      const dialogRef = this.dialogref.open(PopuppatientsearchComponent, {
        data: {
          dataKey: this.patientsSelectedData,
        },
        width:'80%'
      });
      dialogRef.afterClosed().subscribe((result) => {});
      const dialogSubmitSubscription =
        dialogRef.componentInstance.submitClicked.subscribe((result) => {
          this.patientcode = result.patientCode;
          this.RertivePatient();

          dialogSubmitSubscription.unsubscribe();

        });

    }
    RetrivePatientDocumentsLab(){
      this.PatientDocumentsLabList=[];
      this.Wk_DocCode = -1;
      this.patientdocumentsservice.GetPatientDocuments('Lab',this.patientcode, this.compcode).subscribe(
        (data: PatientDocumentsModel[]) => {
          for (let i = 0; i < data.length; i++) {
          this.PatientDocumentsLabList[i] = data[i];
          this.PatientDocumentsLabList[i].id = data[i].id;
          this.PatientDocumentsLabList[i].pathimage_1 = data[i].pathimage;
          this.PatientDocumentsLabList[i].docdate = formatDate(data[i].docdate, 'yyyy-MM-dd', 'en');
          if(this.PatientDocumentsLabList[i].doctype == 'PDF'){this.PatientDocumentsLabList[i].pathimage_1 = '../assets/Documents/pdf.jpg' }
          if(this.PatientDocumentsLabList[i].doctype == 'Excel'){this.PatientDocumentsLabList[i].pathimage_1 = '../assets/Documents/excel.jpg' }
          if(this.PatientDocumentsLabList[i].doctype == 'Word'){this.PatientDocumentsLabList[i].pathimage_1 = '../assets/Documents/Word.jpg' }
          if(this.PatientDocumentsLabList[i].doctype == 'Image'){ //this.PatientDocumentsList[i].pathimage_1 = '../assets/Documents/Image.jpg'
            this.PatientDocumentsLabList[i].pathimage_1 = this.urlsconfig.StaticFilepath + data[i].pathimage;
          }
          this.Wk_DocCode = i;
          ////================================================================================
          }
        }
      );
    }
    openlink(sup :PatientDocumentsModel){
        this.wk_url =sup.docnotes;
        window.open(this.wk_url, '_blank'); // '_blank' opens in a new tab
        //window.open('https://' + this.wk_url, '_blank'); // '_blank' opens in a new tab

      // window.location.href = url; // Redirects to the new website in the same tab

    }
    openWebsite() {
    }
    RetrivePatientDocumentsPathology(){
      this.PatientDocumentsPathologyList=[];
      this.Wk_DocCode = -1;
      this.patientdocumentsservice.GetPatientDocuments('Pathology',this.patientcode, this.compcode).subscribe(
        (data: PatientDocumentsModel[]) => {
          for (let i = 0; i < data.length; i++) {
          this.PatientDocumentsPathologyList[i] = data[i];
          this.PatientDocumentsPathologyList[i].id = data[i].id;
          this.PatientDocumentsPathologyList[i].pathimage_1 = data[i].pathimage;
          this.PatientDocumentsPathologyList[i].docdate = formatDate(data[i].docdate, 'yyyy-MM-dd', 'en');
          if(this.PatientDocumentsPathologyList[i].doctype == 'PDF'){this.PatientDocumentsPathologyList[i].pathimage_1 = '../assets/Documents/pdf.jpg' }
          if(this.PatientDocumentsPathologyList[i].doctype == 'Excel'){this.PatientDocumentsPathologyList[i].pathimage_1 = '../assets/Documents/excel.jpg' }
          if(this.PatientDocumentsPathologyList[i].doctype == 'Word'){this.PatientDocumentsPathologyList[i].pathimage_1 = '../assets/Documents/Word.jpg' }
          if(this.PatientDocumentsPathologyList[i].doctype == 'Image'){ //this.PatientDocumentsList[i].pathimage_1 = '../assets/Documents/Image.jpg'
            this.PatientDocumentsPathologyList[i].pathimage_1 = this.urlsconfig.StaticFilepath + data[i].pathimage;

          }

          this.Wk_DocCode = i;
          ////================================================================================
          }

        }

      );
    }
    RetrivePatientDocumentsImage(){
      this.PatientDocumentsImageList=[];
      this.Wk_DocCode = -1;
      this.patientdocumentsservice.GetPatientDocuments('Image',this.patientcode, this.compcode).subscribe(
        (data: PatientDocumentsModel[]) => {
          for (let i = 0; i < data.length; i++) {
          this.PatientDocumentsImageList[i] = data[i];
          this.PatientDocumentsImageList[i].id = data[i].id;
          this.PatientDocumentsImageList[i].pathimage_1 = data[i].pathimage;
          this.PatientDocumentsImageList[i].docdate = formatDate(data[i].docdate, 'yyyy-MM-dd', 'en');
          if(this.PatientDocumentsImageList[i].doctype == 'PDF'){this.PatientDocumentsImageList[i].pathimage_1 = '../assets/Documents/pdf.jpg' }
          if(this.PatientDocumentsImageList[i].doctype == 'Excel'){this.PatientDocumentsImageList[i].pathimage_1 = '../assets/Documents/excel.jpg' }
          if(this.PatientDocumentsImageList[i].doctype == 'Word'){this.PatientDocumentsImageList[i].pathimage_1 = '../assets/Documents/Word.jpg' }
          if(this.PatientDocumentsImageList[i].doctype == 'Image'){ //this.PatientDocumentsList[i].pathimage_1 = '../assets/Documents/Image.jpg'
            this.PatientDocumentsImageList[i].pathimage_1 = this.urlsconfig.StaticFilepath + data[i].pathimage;

          }

          this.Wk_DocCode = i;
          ////================================================================================
          }

        }

      );
    }
    RetrivePatientDocumentsTreatment(){
      this.PatientDocumentsTreatmnetList=[];
      this.Wk_DocCode = -1;
      this.patientdocumentsservice.GetPatientDocuments('Treatment',this.patientcode, this.compcode).subscribe(
        (data: PatientDocumentsModel[]) => {
          for (let i = 0; i < data.length; i++) {
          this.PatientDocumentsTreatmnetList[i] = data[i];
          this.PatientDocumentsTreatmnetList[i].id = data[i].id;
          this.PatientDocumentsTreatmnetList[i].pathimage_1 = data[i].pathimage;
          this.PatientDocumentsTreatmnetList[i].docdate = formatDate(data[i].docdate, 'yyyy-MM-dd', 'en');
          if(this.PatientDocumentsTreatmnetList[i].doctype == 'PDF'){this.PatientDocumentsTreatmnetList[i].pathimage_1 = '../assets/Documents/pdf.jpg' }
          if(this.PatientDocumentsTreatmnetList[i].doctype == 'Excel'){this.PatientDocumentsTreatmnetList[i].pathimage_1 = '../assets/Documents/excel.jpg' }
          if(this.PatientDocumentsTreatmnetList[i].doctype == 'Word'){this.PatientDocumentsTreatmnetList[i].pathimage_1 = '../assets/Documents/Word.jpg' }
          if(this.PatientDocumentsTreatmnetList[i].doctype == 'Image'){ //this.PatientDocumentsList[i].pathimage_1 = '../assets/Documents/Image.jpg'
            this.PatientDocumentsTreatmnetList[i].pathimage_1 = this.urlsconfig.StaticFilepath + data[i].pathimage;

          }

          this.Wk_DocCode = i;
          ////================================================================================
          }

        }

      );
    }
    RetrivePatientDocumentsTest(){
      this.PatientDocumentsTestList=[];
      this.Wk_DocCode = -1;
      this.patientdocumentsservice.GetPatientDocuments('Testing',this.patientcode, this.compcode).subscribe(
        (data: PatientDocumentsModel[]) => {
          for (let i = 0; i < data.length; i++) {
          this.PatientDocumentsTestList[i] = data[i];
          this.PatientDocumentsTestList[i].id = data[i].id;
          this.PatientDocumentsTestList[i].pathimage_1 = data[i].pathimage;
          this.PatientDocumentsTestList[i].docdate = formatDate(data[i].docdate, 'yyyy-MM-dd', 'en');
          if(this.PatientDocumentsTestList[i].doctype == 'PDF'){this.PatientDocumentsTestList[i].pathimage_1 = '../assets/Documents/pdf.jpg' }
          if(this.PatientDocumentsTestList[i].doctype == 'Excel'){this.PatientDocumentsTestList[i].pathimage_1 = '../assets/Documents/excel.jpg' }
          if(this.PatientDocumentsTestList[i].doctype == 'Word'){this.PatientDocumentsTestList[i].pathimage_1 = '../assets/Documents/Word.jpg' }
          if(this.PatientDocumentsTestList[i].doctype == 'Image'){ //this.PatientDocumentsList[i].pathimage_1 = '../assets/Documents/Image.jpg'
             this.PatientDocumentsTestList[i].pathimage_1 = this.urlsconfig.StaticFilepath + data[i].pathimage;

          }

          this.Wk_DocCode = i;
          ////================================================================================
          }

        }

      );
    }
    RetrivePatientDocumentsPhoto(){
      this.PatientDocumentsPhotoList=[];
      this.Wk_DocCode = -1;
      this.patientdocumentsservice.GetPatientDocuments('Photo',this.patientcode, this.compcode).subscribe(
        (data: PatientDocumentsModel[]) => {
          for (let i = 0; i < data.length; i++) {
          this.PatientDocumentsPhotoList[i] = data[i];
          this.PatientDocumentsPhotoList[i].id = data[i].id;
          this.PatientDocumentsPhotoList[i].pathimage_1 = data[i].pathimage;
          this.PatientDocumentsPhotoList[i].docdate = formatDate(data[i].docdate, 'yyyy-MM-dd', 'en');
          if(this.PatientDocumentsPhotoList[i].doctype == 'PDF'){this.PatientDocumentsPhotoList[i].pathimage_1 = '../assets/Documents/pdf.jpg' }
          if(this.PatientDocumentsPhotoList[i].doctype == 'Excel'){this.PatientDocumentsPhotoList[i].pathimage_1 = '../assets/Documents/excel.jpg' }
          if(this.PatientDocumentsPhotoList[i].doctype == 'Word'){this.PatientDocumentsPhotoList[i].pathimage_1 = '../assets/Documents/Word.jpg' }
          if(this.PatientDocumentsPhotoList[i].doctype == 'Image'){ //this.PatientDocumentsList[i].pathimage_1 = '../assets/Documents/Image.jpg'
             this.PatientDocumentsPhotoList[i].pathimage_1 = this.urlsconfig.StaticFilepath + data[i].pathimage;

          }

          this.Wk_DocCode = i;
          ////================================================================================
          }

        }

      );
    }
    RetrivePatientDocumentsOther(){
      this.PatientDocumentsOtherList=[];
      this.Wk_DocCode = -1;
      this.patientdocumentsservice.GetPatientDocuments('Other',this.patientcode, this.compcode).subscribe(
        (data: PatientDocumentsModel[]) => {
          for (let i = 0; i < data.length; i++) {
          this.PatientDocumentsOtherList[i] = data[i];
          this.PatientDocumentsOtherList[i].id = data[i].id;
          this.PatientDocumentsOtherList[i].pathimage_1 = data[i].pathimage;
          this.PatientDocumentsOtherList[i].docdate = formatDate(data[i].docdate, 'yyyy-MM-dd', 'en');
          if(this.PatientDocumentsOtherList[i].doctype == 'PDF'){this.PatientDocumentsOtherList[i].pathimage_1 = '../assets/Documents/pdf.jpg' }
          if(this.PatientDocumentsOtherList[i].doctype == 'Excel'){this.PatientDocumentsOtherList[i].pathimage_1 = '../assets/Documents/excel.jpg' }
          if(this.PatientDocumentsOtherList[i].doctype == 'Word'){this.PatientDocumentsOtherList[i].pathimage_1 = '../assets/Documents/Word.jpg' }
          if(this.PatientDocumentsOtherList[i].doctype == 'Image'){ //this.PatientDocumentsList[i].pathimage_1 = '../assets/Documents/Image.jpg'
             this.PatientDocumentsOtherList[i].pathimage_1 = this.urlsconfig.StaticFilepath + data[i].pathimage;

          }

          this.Wk_DocCode = i;
          ////================================================================================
          }

        }

      );
    }
    RetrivePatientDocumentsRadio(){
      this.PatientDocumentsRadioList=[];
      this.Wk_DocCode = -1;
      this.patientdocumentsservice.GetPatientDocuments('Radio',this.patientcode, this.compcode).subscribe(
        (data: PatientDocumentsModel[]) => {
          for (let i = 0; i < data.length; i++) {
          this.PatientDocumentsRadioList[i] = data[i];
          this.PatientDocumentsRadioList[i].id = data[i].id;
          this.PatientDocumentsRadioList[i].pathimage_1 = data[i].pathimage;
          this.PatientDocumentsRadioList[i].docdate = formatDate(data[i].docdate, 'yyyy-MM-dd', 'en');
          if(this.PatientDocumentsRadioList[i].doctype == 'PDF'){this.PatientDocumentsRadioList[i].pathimage_1 = '../assets/Documents/pdf.jpg' }
          if(this.PatientDocumentsRadioList[i].doctype == 'Excel'){this.PatientDocumentsRadioList[i].pathimage_1 = '../assets/Documents/excel.jpg' }
          if(this.PatientDocumentsRadioList[i].doctype == 'Word'){this.PatientDocumentsRadioList[i].pathimage_1 = '../assets/Documents/Word.jpg' }
          if(this.PatientDocumentsRadioList[i].doctype == 'Image'){ //this.PatientDocumentsList[i].pathimage_1 = '../assets/Documents/Image.jpg'
             this.PatientDocumentsRadioList[i].pathimage_1 = this.urlsconfig.StaticFilepath + data[i].pathimage;

          }

          this.Wk_DocCode = i;
          ////================================================================================
          }

        }

      );
    }
    //////**************************************************************************** */
    openDialogTransEditLab(sup :PatientDocumentsModel){

      const dialogRef = this.dialogref.open(PatientDocumentsEditComponent,
        {
          data: {
            dataKey: this.patientdocuments,
            patientcode : this.patientcode,
            docid :sup.id,
            doccode :sup.doccode,
            docname :sup.docname,
            docdate :sup.docdate,
            doctype :sup.doctype,
            docnotes :sup.docnotes,
            pathimage: sup.pathimage,
            pathimage_1: sup.pathimage_1,
            fileBytes : 'Ex',
            documenttype : 'Lab'

          },
          width: '60vw',


        });
      dialogRef.afterClosed().subscribe(result => {
        this.RetrivePatientDocumentsLab();
      });
      const dialogSubmitSubscription =
        dialogRef.componentInstance.submitClicked.subscribe(result => {
          dialogSubmitSubscription.unsubscribe();
        });

    }
    openDialogTransEditImage(sup :PatientDocumentsModel){
      const dialogRef = this.dialogref.open(PatientDocumentsEditComponent,
        {
          data: {
            dataKey: this.patientdocuments,
            patientcode : this.patientcode,
            docid :sup.id,
            doccode :sup.doccode,
            docname :sup.docname,
            docdate :sup.docdate,
            doctype :sup.doctype,
            docnotes :sup.docnotes,
            pathimage: sup.pathimage,
            pathimage_1: sup.pathimage_1,
            fileBytes : 'Ex',
            documenttype : 'Image'
          },
          width: '60vw',
        });
      dialogRef.afterClosed().subscribe(result => {
        this.RetrivePatientDocumentsImage();
      });
      const dialogSubmitSubscription =
        dialogRef.componentInstance.submitClicked.subscribe(result => {
          dialogSubmitSubscription.unsubscribe();
        });

    }
    openDialogTransEditPathology(sup :PatientDocumentsModel){
      const dialogRef = this.dialogref.open(PatientDocumentsEditComponent,
        {
          data: {
            dataKey: this.patientdocuments,
            patientcode : this.patientcode,
            docid :sup.id,
            doccode :sup.doccode,
            docname :sup.docname,
            docdate :sup.docdate,
            doctype :sup.doctype,
            docnotes :sup.docnotes,
            pathimage: sup.pathimage,
            pathimage_1: sup.pathimage_1,
            fileBytes : 'Ex',
            documenttype : 'Pathology'

          },
          width: '60vw',


        });
      dialogRef.afterClosed().subscribe(result => {
        this.RetrivePatientDocumentsPathology();
      });
      const dialogSubmitSubscription =
        dialogRef.componentInstance.submitClicked.subscribe(result => {
          dialogSubmitSubscription.unsubscribe();
        });

    }
    openDialogTransEditPhoto(sup :PatientDocumentsModel){
      const dialogRef = this.dialogref.open(PatientDocumentsEditComponent,
        {
          data: {
            dataKey: this.patientdocuments,
            patientcode : this.patientcode,
            docid :sup.id,
            doccode :sup.doccode,
            docname :sup.docname,
            docdate :sup.docdate,
            doctype :sup.doctype,
            docnotes :sup.docnotes,
            pathimage: sup.pathimage,
            pathimage_1: sup.pathimage_1,
            fileBytes : 'Ex',
            documenttype : 'Photo'
          },
          width: '60vw',


        });
      dialogRef.afterClosed().subscribe(result => {
        this.RetrivePatientDocumentsPhoto();
      });
      const dialogSubmitSubscription =
        dialogRef.componentInstance.submitClicked.subscribe(result => {
          dialogSubmitSubscription.unsubscribe();
        });
    }
    openDialogTransEditOther(sup :PatientDocumentsModel){
      const dialogRef = this.dialogref.open(PatientDocumentsEditComponent,
        {
          data: {
            dataKey: this.patientdocuments,
            patientcode : this.patientcode,
            docid :sup.id,
            doccode :sup.doccode,
            docname :sup.docname,
            docdate :sup.docdate,
            doctype :sup.doctype,
            docnotes :sup.docnotes,
            pathimage: sup.pathimage,
            pathimage_1: sup.pathimage_1,
            fileBytes : 'Ex',
            documenttype : 'Other'
          },
          width: '60vw',
        });
      dialogRef.afterClosed().subscribe(result => {
        this.RetrivePatientDocumentsOther();
      });
      const dialogSubmitSubscription =
        dialogRef.componentInstance.submitClicked.subscribe(result => {
          dialogSubmitSubscription.unsubscribe();
        });
    }
    openDialogTransEditTesting(sup :PatientDocumentsModel){
      const dialogRef = this.dialogref.open(PatientDocumentsEditComponent,
        {
          data: {
            dataKey: this.patientdocuments,
            patientcode : this.patientcode,
            docid :sup.id,
            doccode :sup.doccode,
            docname :sup.docname,
            docdate :sup.docdate,
            doctype :sup.doctype,
            docnotes :sup.docnotes,
            pathimage: sup.pathimage,
            pathimage_1: sup.pathimage_1,
            fileBytes : 'Ex',
            documenttype : 'Testing'
          },
          width: '60vw',
        });
      dialogRef.afterClosed().subscribe(result => {
        this.RetrivePatientDocumentsTest();
      });
      const dialogSubmitSubscription =
        dialogRef.componentInstance.submitClicked.subscribe(result => {
          dialogSubmitSubscription.unsubscribe();
        });
    }
    openDialogTransEditTreatment(sup :PatientDocumentsModel){
      const dialogRef = this.dialogref.open(PatientDocumentsEditComponent,
        {
          data: {
            dataKey: this.patientdocuments,
            patientcode : this.patientcode,
            docid :sup.id,
            doccode :sup.doccode,
            docname :sup.docname,
            docdate :sup.docdate,
            doctype :sup.doctype,
            docnotes :sup.docnotes,
            pathimage: sup.pathimage,
            pathimage_1: sup.pathimage_1,
            fileBytes : 'Ex',
            documenttype : 'Treatment'
          },
          width: '60vw',
        });
      dialogRef.afterClosed().subscribe(result => {
        this.RetrivePatientDocumentsTest();
      });
      const dialogSubmitSubscription =
        dialogRef.componentInstance.submitClicked.subscribe(result => {
          dialogSubmitSubscription.unsubscribe();
        });
    }
    openDialogViwer(sup :PatientDocumentsModel){

      return (this.urlsconfig.StaticFilepath + sup.pathimage);

    }
    openDialogTransEditRadio(sup :PatientDocumentsModel){
      const dialogRef = this.dialogref.open(PatientDocumentsEditComponent,
        {
          data: {
            dataKey: this.patientdocuments,
            patientcode : this.patientcode,
            docid :sup.id,
            doccode :sup.doccode,
            docname :sup.docname,
            docdate :sup.docdate,
            doctype :sup.doctype,
            docnotes :sup.docnotes,
            pathimage: sup.pathimage,
            pathimage_1: sup.pathimage_1,
            fileBytes : 'Ex',
            documenttype : 'Radio'
          },
          width: '60vw',
        });
      dialogRef.afterClosed().subscribe(result => {
        this.RetrivePatientDocumentsRadio();
      });
      const dialogSubmitSubscription =
        dialogRef.componentInstance.submitClicked.subscribe(result => {
          dialogSubmitSubscription.unsubscribe();
        });
    }
//////////-----------New Record -----------------------------------
    DialogNewRecordLab(){

      this.patientdocumentsservice.GetDocumentsSerial(this.patientcode, this.compcode).subscribe(
        (data: PatientDocumentsModel) => {

          this.Wk_DocCode = Number(data.doccode);

        const dialogRef = this.dialogref.open(PatientDocumentsEditComponent,
        {
          data: {
            dataKey: this.patientdocuments,
            patientcode : this.patientcode,
            docid :0,
            doccode :this.Wk_DocCode +1,
            docdate :formatDate(new Date(), 'yyyy-MM-dd', 'en'),
            doctype : 'PDF',
            docnotes :'',
            pathimage: '',
            pathimage_1: '../assets/Documents/pdf.jpg',
            fileBytes : 'New',
            documenttype : 'Lab'

          },
          width: '60vw',


        });
      dialogRef.afterClosed().subscribe(result => {
        this.RetrivePatientDocumentsLab();
      });
      const dialogSubmitSubscription =
        dialogRef.componentInstance.submitClicked.subscribe(result => {
          dialogSubmitSubscription.unsubscribe();
        });
      });
    }
    DialogNewRecordPathology(){
      this.patientdocumentsservice.GetDocumentsSerial(this.patientcode, this.compcode).subscribe(
        (data: PatientDocumentsModel) => {

          this.Wk_DocCode = Number(data.doccode);

      const dialogRef = this.dialogref.open(PatientDocumentsEditComponent,
        {
          data: {
            dataKey: this.patientdocuments,
            patientcode : this.patientcode,
            docid :0,
            doccode :this.Wk_DocCode +1,
            docdate :formatDate(new Date(), 'yyyy-MM-dd', 'en'),
            doctype : 'PDF',
            docnotes :'',
            pathimage: '',
            pathimage_1: '../assets/Documents/pdf.jpg',
            fileBytes : 'New',
            documenttype : 'Pathology'
          },
          width: '60vw',
        });
      dialogRef.afterClosed().subscribe(result => {
        this.RetrivePatientDocumentsPathology();
      });
      const dialogSubmitSubscription =
        dialogRef.componentInstance.submitClicked.subscribe(result => {
          dialogSubmitSubscription.unsubscribe();
        });
      });
    }
    DialogNewRecordImage(){
      this.patientdocumentsservice.GetDocumentsSerial(this.patientcode, this.compcode).subscribe(
        (data: PatientDocumentsModel) => {

          this.Wk_DocCode = Number(data.doccode);

      const dialogRef = this.dialogref.open(PatientDocumentsEditComponent,
        {
          data: {
            dataKey: this.patientdocuments,
            patientcode : this.patientcode,
            docid :0,
            doccode :this.Wk_DocCode +1,
            docdate :formatDate(new Date(), 'yyyy-MM-dd', 'en'),
            doctype : 'PDF',
            docnotes :'',
            pathimage: '',
            pathimage_1: '../assets/Documents/pdf.jpg',
            fileBytes : 'New',
            documenttype : 'Image'

          },
          width: '60vw',


        });
      dialogRef.afterClosed().subscribe(result => {
        this.RetrivePatientDocumentsImage();
      });
      const dialogSubmitSubscription =
        dialogRef.componentInstance.submitClicked.subscribe(result => {
          dialogSubmitSubscription.unsubscribe();
        });
      });
    }
    DialogNewRecordTesting(){
      this.patientdocumentsservice.GetDocumentsSerial(this.patientcode, this.compcode).subscribe(
        (data: PatientDocumentsModel) => {

          this.Wk_DocCode = Number(data.doccode);

      const dialogRef = this.dialogref.open(PatientDocumentsEditComponent,
        {
          data: {
            dataKey: this.patientdocuments,
            patientcode : this.patientcode,
            docid :0,
            doccode :this.Wk_DocCode +1,
            docdate :formatDate(new Date(), 'yyyy-MM-dd', 'en'),
            doctype : 'PDF',
            docnotes :'',
            pathimage: '',
            pathimage_1: '../assets/Documents/pdf.jpg',
            fileBytes : 'New',
            documenttype : 'Testing'

          },
          width: '60vw',


        });
      dialogRef.afterClosed().subscribe(result => {
        this.RetrivePatientDocumentsTest();
      });
      const dialogSubmitSubscription =
        dialogRef.componentInstance.submitClicked.subscribe(result => {
          dialogSubmitSubscription.unsubscribe();
        });
      });
    }
    DialogNewRecordPhoto(){
      this.patientdocumentsservice.GetDocumentsSerial(this.patientcode, this.compcode).subscribe(
        (data: PatientDocumentsModel) => {

          this.Wk_DocCode = Number(data.doccode);

      const dialogRef = this.dialogref.open(PatientDocumentsEditComponent,
        {
          data: {
            dataKey: this.patientdocuments,
            patientcode : this.patientcode,
            docid :0,
            doccode :this.Wk_DocCode +1,
            docdate :formatDate(new Date(), 'yyyy-MM-dd', 'en'),
            doctype : 'PDF',
            docnotes :'',
            pathimage: '',
            pathimage_1: '../assets/Documents/pdf.jpg',
            fileBytes : 'New',
            documenttype : 'Photo'

          },
          width: '60vw',


        });
      dialogRef.afterClosed().subscribe(result => {
        this.RetrivePatientDocumentsPhoto();
      });
      const dialogSubmitSubscription =
        dialogRef.componentInstance.submitClicked.subscribe(result => {
          dialogSubmitSubscription.unsubscribe();
        });
      });
    }
    DialogNewRecordOther(){
      this.patientdocumentsservice.GetDocumentsSerial(this.patientcode, this.compcode).subscribe(
        (data: PatientDocumentsModel) => {

          this.Wk_DocCode = Number(data.doccode);

      const dialogRef = this.dialogref.open(PatientDocumentsEditComponent,
        {
          data: {
            dataKey: this.patientdocuments,
            patientcode : this.patientcode,
            docid :0,
            doccode :this.Wk_DocCode +1,
            docdate :formatDate(new Date(), 'yyyy-MM-dd', 'en'),
            doctype : 'PDF',
            docnotes :'',
            pathimage: '',
            pathimage_1: '../assets/Documents/pdf.jpg',
            fileBytes : 'New',
            documenttype : 'Other'

          },
          width: '60vw',


        });
      dialogRef.afterClosed().subscribe(result => {
        this.RetrivePatientDocumentsOther();
      });
      const dialogSubmitSubscription =
        dialogRef.componentInstance.submitClicked.subscribe(result => {
          dialogSubmitSubscription.unsubscribe();
        });
      });
    }
    DialogNewRecordTreatment(){

      this.patientdocumentsservice.GetDocumentsSerial(this.patientcode, this.compcode).subscribe(
        (data: PatientDocumentsModel) => {
          this.Wk_DocCode = Number(data.doccode) ;

      const dialogRef = this.dialogref.open(PatientDocumentsEditComponent,
        {
          data: {
            dataKey: this.patientdocuments,
            patientcode : this.patientcode,
            docid :0,
            doccode :this.Wk_DocCode +1,
            docdate :formatDate(new Date(), 'yyyy-MM-dd', 'en'),
            doctype : 'PDF',
            docnotes :'',
            pathimage: '',
            pathimage_1: '../assets/Documents/pdf.jpg',
            fileBytes : 'New',
            documenttype : 'Treatment'

          },
          width: '60vw',


        });
      dialogRef.afterClosed().subscribe(result => {
        this.RetrivePatientDocumentsTreatment();
      });
      const dialogSubmitSubscription =
        dialogRef.componentInstance.submitClicked.subscribe(result => {
          dialogSubmitSubscription.unsubscribe();
        });
      });
    }
    DialogNewRecordRadio(){

      this.patientdocumentsservice.GetDocumentsSerial(this.patientcode, this.compcode).subscribe(
        (data: PatientDocumentsModel) => {
          this.Wk_DocCode = Number(data.doccode) ;

      const dialogRef = this.dialogref.open(PatientDocumentsEditComponent,
        {
          data: {
            dataKey: this.patientdocuments,
            patientcode : this.patientcode,
            docid :0,
            doccode :this.Wk_DocCode +1,
            docdate :formatDate(new Date(), 'yyyy-MM-dd', 'en'),
            doctype : 'PDF',
            docnotes :'',
            pathimage: '',
            pathimage_1: '../assets/Documents/pdf.jpg',
            fileBytes : 'New',
            documenttype : 'Radio'

          },
          width: '60vw',


        });
      dialogRef.afterClosed().subscribe(result => {
        this.RetrivePatientDocumentsRadio();
      });
      const dialogSubmitSubscription =
        dialogRef.componentInstance.submitClicked.subscribe(result => {
          dialogSubmitSubscription.unsubscribe();
        });
      });
    }
    Cloase_Dialog(){
     this.storage.store('stgPatientCode',this.patientcode);
     window.close();
    }
    mesgDelete(){}

  }

